<div class="faq-wrapper">
  <mat-accordion multi displayMode="flat" class="faq">
    @for (topic of faqTopics; track topic) {
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h3 [innerHTML]="textkeyPrefix + '.faq.' + topic + '.headline' | translate"></h3>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div [innerHTML]="textkeyPrefix + '.faq.' + topic + '.text' | translate"></div>
      </mat-expansion-panel>
    }
  </mat-accordion>
</div>
